<template>
  <div class="container containerForm">
    <h2 style="text-align: center">تعديل بيانات المنتج</h2>
    <form>
      <div class="form-group">
        <label for="name">الاسم</label>
        <input type="text" class="form-control" id="name" v-model="editedProduct.name"
          :class="{ 'is-invalid': errors.name }" />
        <div v-if="errors.name" class="invalid-feedback">
          {{ errors.name }}
        </div>
      </div>
      <div class="form-group">
        <label for="description">الوصف بالإنجليزية</label>
        <textarea class="form-control" style="height: 100px" id="description" v-model="editedProduct.description"
          :class="{ 'is-invalid': errors.description }"></textarea>
        <div v-if="errors.description" class="invalid-feedback">
          {{ errors.description }}
        </div>
      </div>
      <div class="form-group">
        <label for="description_ar">الوصف بالعربية</label>
        <textarea class="form-control" style="height: 100px" id="description_ar" v-model="editedProduct.description_ar"
          :class="{ 'is-invalid': errors.description_ar }"></textarea>
        <div v-if="errors.description_ar" class="invalid-feedback">
          {{ errors.description_ar }}
        </div>
      </div>
      <div class="form-group">
        <label for="height">الطول</label>
        <input type="text" class="form-control" id="height" v-model="editedProduct.height"
          :class="{ 'is-invalid': errors.height }" />
        <div v-if="errors.height" class="invalid-feedback">
          {{ errors.height }}
        </div>
      </div>

      <!-- <div class="form-group">
        <label for="height_ar">الطول بالعربية</label>
        <input type="text" class="form-control" id="height_ar" v-model="editedProduct.height_ar"
          :class="{ 'is-invalid': errors.height_ar }" />
        <div v-if="errors.height_ar" class="invalid-feedback">
          {{ errors.height_ar }}
        </div>
      </div> -->

      <div class="form-group">
        <label for="style">الاستايل بالإنجليزية</label>
        <input type="text" class="form-control" id="style" v-model="editedProduct.style"
          :class="{ 'is-invalid': errors.style }" />
        <div v-if="errors.style" class="invalid-feedback">
          {{ errors.style }}
        </div>
      </div>

      <div class="form-group">
        <label for="style_ar">الاستايل بالعربية</label>
        <input type="text" class="form-control" id="style_ar" v-model="editedProduct.style_ar"
          :class="{ 'is-invalid': errors.style_ar }" />
        <div v-if="errors.style_ar" class="invalid-feedback">
          {{ errors.style_ar }}
        </div>
      </div>

      <div class="form-group">
        <label for="depth">العرض</label>
        <input type="text" class="form-control" id="depth" v-model="editedProduct.depth"
          :class="{ 'is-invalid': errors.depth }" />
        <div v-if="errors.depth" class="invalid-feedback">
          {{ errors.depth }}
        </div>
      </div>

      <!-- <div class="form-group">
        <label for="depth_ar">العرض بالعربية</label>
        <input type="number" class="form-control" id="depth_ar" v-model="editedProduct.depth_ar"
          :class="{ 'is-invalid': errors.depth_ar }" />
        <div v-if="errors.depth_ar" class="invalid-feedback">
          {{ errors.depth_ar }}
        </div>
      </div> -->

      <div class="form-group">
        <label for="execute_ar">هل تم تنفيذ المنتج من قبل؟</label>
        <select class="form-control" id="execute_ar" v-model="editedProduct.execute_ar">
          <option value="">قم بالاختيار</option>
          <option value="تم التنفيذ بمقاس من قبل">
            تم التنفيذ بمقاس من قبل
          </option>
          <option value="لم يتم التنفيذ بمقاس من قبل">
            لم يتم التنفيذ بمقاس من قبل
          </option>
        </select>
      </div>
      <div class="form-group">
        <label for="category">القسم</label>
        <select class="form-control" id="category" v-model="editedProduct.categoryId">
          <option value="">اختر قسمًا</option>
          <option v-for="category in categories" :value="category.id" :key="category.id">
            {{ category.name_ar }}
          </option>
        </select>
      </div>
      <div class="form-group">
        <label for="image">صورة المنتج</label>
        <input type="file" accept="image/*" class="form-control" id="image" @change="handleImageChange" />
      </div>
      <div class="row">
        <div class="d-flex">
          <label for="materials" class="pt-2">المواد الخام</label>
          <button class="btn btn-primary mx-2 px-4" @click.prevent="addMaterialPrice()">
            <i class="fas fa-plus icon-primary"></i>
          </button>
        </div>
        <div>
          <table class="table materialsTable mt-3">
            <thead>
              <tr>
                <th style="text-align: center !important; width:30%;">المادة بالعربية</th>
                <th style="text-align: center !important; width:30%;">السعر</th>
                <th style="text-align: center !important;">حذف الخامة</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="materialPrice in editedProduct.materialsProductData" :key="materialPrice.id">
                <td>{{ materialPrice.Material.name_ar }}</td>
                <td>
                  <div v-if="!editModes[materialPrice.id]">
                    {{ materialPrice.price }}
                    <button class="btn btn-primary btn-primary-add" @click.prevent="toggleEditMode(materialPrice.id)">
                      <i class="fas fa-edit icon-primary"></i>
                    </button>
                  </div>
                  <div v-else>
                    <input type="number" v-model="materialPrice.editPrice" @keyup.enter="savePrice(materialPrice.id)"
                      style="width: 50%;" class="text-center border">
                    <button @click.prevent="savePrice(materialPrice.id)" class="mx-2">حفظ</button>
                    <button @click.prevent="toggleEditMode(materialPrice.id)">إلغاء</button>
                  </div>
                </td>
                <td>
                  <button class="btn btn-danger" @click.prevent="deleteMaterialPrice(materialPrice.id)">
                    <i class="fas fa-trash-alt icon-danger"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <button type="submit" class="btn btn-primary" @click.prevent="updateProduct">
        حفظ
      </button>
    </form>
  </div>
</template>

<script>
import Axios from "../../../Axios";
import Swal from "sweetalert2";

export default {
  data() {
    return {
      editedProduct: {
        name: "",
        description: "",
        description_ar: "",
        height: "",
        style: "",
        style_ar: "",
        depth: "",
        // material: "",
        // material_ar: "",
        // price: "",
        // price_ar: "",
        categoryId: "",
        execute_ar: "",
        execute: "",
        image: "",
        selectedMaterials: [],
        materialsProductData: [],
      },
      errors: {
        name: "",
        description: "",
        description_ar: "",
        height: "",
        style: "",
        style_ar: "",
        depth: "",
        // material: "",
        // material_ar: "",
        // price: "",
        // price_ar: "",
      },
      categories: [],
      materialsData: [],
      productId: this.$route.params.id,
      editModes: {},
    };
  },

  methods: {
    saveProductMaterials(selectedMaterials) {
  // Assuming selectedMaterials is an array of { materialID, price }
  const formData = new FormData();
  
  // Append the productID
  formData.append("productID", this.productId);

  // Loop through each selected material and append its details
  selectedMaterials.forEach(material => {
    formData.append("materialID", material.materialID);
    formData.append("price", material.price);
  });

  // Make the API call
  Axios.post("https://jebsenboard.onrender.com/dashboard/materialsPrices", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  })
  .then((response) => {
    // Handle success
    // console.log("Materials saved successfully:", response);
    this.$iziToast.success({
      timeout: 2000,
      message: "تم حفظ الخامات بنجاح",
      position: "bottomRight",
    });
    this.fetchProductDetails();
  })
  .catch((error) => {
    // Handle error
    // console.error("Error saving materials:", error);
    this.$iziToast.error({
      timeout: 5000,
      message: "حدث خطأ أثناء حفظ الخامات، تأكد من عدم تكرار الخامة",
      position: "bottomRight",
    });
  });
},
    updateProduct() {
      if (this.editedProduct.execute_ar === "تم التنفيذ بمقاس من قبل") {
        this.editedProduct.execute = "Executed with a measurement";
      } else if (
        this.editedProduct.execute_ar === "لم يتم التنفيذ بمقاس من قبل"
      ) {
        this.editedProduct.execute = "Not executed with a previous measurement";
      }
      // Reset previous errors
      this.errors = {
        description: "",
        description_ar: "",
        height: "",
        style: "",
        style_ar: "",
        depth: "",
        // material: "",
        // material_ar: "",
        // price: "",
        // price_ar: "",
      };
      // Custom validation for letters
      const arabicLettersRegex = /^[^A-Za-z]*$/; // Arabic letters and spaces
      const englishLettersRegex =
        /^[A-Za-z0-9!@#$%^&*()_+{}\[\]:;<>,.?/~\\\-|'"\s]*$/; // English letters and spaces

      // Validation for required fields
      if (
        !this.editedProduct.description ||
        !this.editedProduct.description_ar ||
        !this.editedProduct.height ||
        !this.editedProduct.style ||
        !this.editedProduct.style_ar ||
        !this.editedProduct.depth ||
        // !this.editedProduct.material ||
        // !this.editedProduct.material_ar ||
        // !this.editedProduct.price ||
        // !this.editedProduct.price_ar ||
        !this.editedProduct.categoryId ||
        !this.editedProduct.execute_ar
      ) {
        if (!this.editedProduct.name) {
          this.errors.name = "الرجاء إدخال الاسم";
        } else {
          if (
            this.editedProduct.name.length < 3 ||
            this.editedProduct.name.length > 100
          ) {
            this.errors.name = "يجب أن يكون الاسم بين 3 و 100 حرف";
          }
        }
        if (!this.editedProduct.description) {
          this.errors.description = "الرجاء إدخال الوصف بالإنجليزية";
        } else {
          if (!englishLettersRegex.test(this.editedProduct.description)) {
            this.errors.description = "الرجاء إدخال حروف إنجليزية فقط";
          }
        }
        if (!this.editedProduct.description_ar) {
          this.errors.description_ar = "الرجاء إدخال الوصف بالعربية";
        } else {
          if (!arabicLettersRegex.test(this.editedProduct.description_ar)) {
            this.errors.description_ar = "الرجاء إدخال حروف عربية فقط";
          }
        }
        if (!this.editedProduct.style) {
          this.errors.style = "الرجاء إدخال الاستايل بالإنجليزية";
        } else {
          if (!englishLettersRegex.test(this.editedProduct.style)) {
            this.errors.style = "الرجاء إدخال حروف إنجليزية فقط";
          }
        }
        if (!this.editedProduct.style_ar) {
          this.errors.style_ar = "الرجاء إدخال الاستايل بالعربية";
        } else {
          if (!arabicLettersRegex.test(this.editedProduct.style_ar)) {
            this.errors.style_ar = "الرجاء إدخال حروف عربية فقط";
          }
        }
        // if (!this.editedProduct.material_ar) {
        //   this.errors.material_ar = "الرجاء إدخال الخامة بالعربية";
        // } else {
        //   if (!arabicLettersRegex.test(this.editedProduct.material_ar)) {
        //     this.errors.material_ar = "الرجاء إدخال حروف عربية فقط";
        //   }
        // }
        // if (!this.editedProduct.material) {
        //   this.errors.material = "الرجاء إدخال الخامة بالإنجليزية";
        // } else {
        //   if (!englishLettersRegex.test(this.editedProduct.material)) {
        //     this.errors.material = "الرجاء إدخال حروف إنجليزية فقط";
        //   }
        // }
        if (
          parseFloat(this.editedProduct.height) <= 0 ||
          isNaN(parseFloat(this.editedProduct.height))
        ) {
          this.errors.height = "يجب أن يكون الطول رقمًا موجبًا";
        }
        if (
          parseFloat(this.editedProduct.depth) <= 0 ||
          isNaN(parseFloat(this.editedProduct.depth))
        ) {
          this.errors.depth = "يجب أن يكون العرض رقمًا موجبًا";
        }
        if (!this.editedProduct.depth_ar) {
          this.errors.depth_ar = "يجب أن يكون العرض رقمًا موجبًا";
        }
        // if (
        //   parseFloat(this.editedProduct.price) <= 0 ||
        //   isNaN(parseFloat(this.editedProduct.price))
        // ) {
        //   this.errors.price = "يجب أن يكون السعر رقمًا موجبًا";
        // }
        // if (!this.editedProduct.price_ar) {
        //   this.errors.price_ar = "يجب أن يكون السعر رقمًا موجبًا";
        // }
        if (!this.editedProduct.execute_ar) {
          this.$iziToast.error({
            timeout: 2000,
            message: "الرجاء تحديد هل تم التنفيذ من قبل أم لا",
            position: "bottomRight",
          });
        }
        if (!this.editedProduct.categoryId) {
          this.$iziToast.error({
            timeout: 2000,
            message: "الرجاء اختيار اسم القسم",
            position: "bottomRight",
          });
        }
        return; // Stop form submission if any required field is missing
      }

      const {
        name,
        description,
        description_ar,
        height,
        style_ar,
        style,
        depth,
        // material,
        // material_ar,
        // price,
        // price_ar,
        categoryId,
        execute_ar,
        execute,
        image,
      } = this.editedProduct;
      // console.log("editedProduct", this.editedProduct);

      // Check if the name has changed
      // console.log(name, this.originalName);
      const id = this.$route.params.id;
      if (name !== this.originalName) {
        // Name has changed, proceed with the update
        Axios.patch(
          `/product/${id}`,
          {
            name: name,
            description: description,
            description_ar: description_ar,
            height: height,
            style: style,
            style_ar: style_ar,
            depth: depth,
            // material: material,
            // material_ar: material_ar,
            // price: price,
            // price_ar: price_ar,
            categoryId: categoryId,
            execute_ar: execute_ar,
            execute: execute,
            image: image,
          },
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
          .then(() => {
            this.$iziToast.success({
              timeout: 2000,
              message: "تم التحديث بنجاح",
              position: "bottomRight",
            });
            this.$router.push("/admin/products");
          })
          .catch((error) => {
            // console.error(error);
            if (error.response && error.response.data) {
              const errorMessage = error.response.data.message;
              this.$iziToast.error({
                timeout: 5000,
                message: errorMessage,
                position: "bottomRight",
              });
            } else {
              this.$iziToast.error({
                timeout: 2000,
                message: "فشل التحديث",
                position: "bottomRight",
              });
            }
          });
      } else {
        // Name hasn't changed, no need to update
        Axios.patch(
          `/product/${id}`,
          {
            description: description,
            description_ar: description_ar,
            height: height,
            style: style,
            style_ar: style_ar,
            depth: depth,
            // material: material,
            // material_ar: material_ar,
            // price: price,
            // price_ar: price_ar,
            categoryId: categoryId,
            execute_ar: execute_ar,
            execute: execute,
            image: image,
          },
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
          .then(() => {
            this.$iziToast.success({
              timeout: 2000,
              message: "تم التحديث بنجاح",
              position: "bottomRight",
            });
            this.$router.push("/admin/products");
          })
          .catch((error) => {
            // console.error(error);
            if (error.response && error.response.data) {
              const errorMessage = error.response.data.message;
              this.$iziToast.error({
                timeout: 5000,
                message: errorMessage,
                position: "bottomRight",
              });
            } else {
              this.$iziToast.error({
                timeout: 2000,
                message: "فشل التحديث",
                position: "bottomRight",
              });
            }
          });
      }
    },

    fetchProductMaterials(id) {
      Axios.get("https://jebsenboard.onrender.com/dashboard/productMaterialPrices/" + id)
        .then((response) => {
          // Assuming the response data is directly the array of materials
          this.editedProduct.materialsProductData = response.data;
          // console.log(this.editedProduct.materialsProductData, "pppp");
        })
        .catch((error) => {
          // console.error(error);
        });
    },

    editMaterialPrice(id) {
      Axios.patch("https://jebsenboard.onrender.com/dashboard/materialsPrices/" + id)
        .then((response) => {
          // console.log(response);
        })
        .catch((error) => {
          // console.error(error);
        });
    },

    deleteMaterialPrice(id) {
      // Show SweetAlert confirmation dialog before deletion
      Swal.fire({
        title: "هل أنت متأكد؟",
        text: "هل تريد حقًا حذف هذه الخامة؟",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "نعم",
        cancelButtonText: "إلغاء",
        dangerMode: true,
      }).then((result) => {
        if (result.isConfirmed) {
          // The user clicked "نعم", perform the deletion
          Axios.delete("dashboard/materialsPrices/" + id)
            .then((response) => {
              // Show success message using SweetAlert
              Swal.fire("تم الحذف!", "تم حذف الخامة بنجاح.", "success");
              this.fetchProductDetails();
            })
            .catch((error) => {
              // console.error(error);
              // Show error message using SweetAlert
              Swal.fire("خطأ!", "حدث خطأ أثناء الحذف.", "error");
            });
        }
      });
    },

    fetchMaterials() {
      Axios.get("/dashboard/materials")
        .then((response) => {
          this.materialsData = response.data.map((material) => {
            const row = {
              "الاسم": material.name_ar + " ",
              "الاسم بالإنجليزية": material.name,
              "الرقم التسلسلي": material.id,
              loading: true,
            };
            return row;
          });
          // console.log(this.materialsData);
        })
        .catch((error) => {
          // console.error(error);
        });
    },

    toggleMaterialSelection(materialId) {
      const materialIndex = this.editedProduct.selectedMaterials.findIndex(m => m.materialID === materialId);
      if (materialIndex > -1) {
        // Material is already selected, remove it
        this.editedProduct.selectedMaterials.splice(materialIndex, 1);
      } else {
        // Material is not selected, add it with a default price
        this.editedProduct.selectedMaterials.push({ materialID: materialId, price: 0 });
      }
    },
    getMaterialPrice(materialId) {
      const material = this.editedProduct.selectedMaterials.find(m => m.materialID === materialId);
      return material ? material.price : 0;
    },

    handleImageChange(event) {
      const selectedImage = event.target.files[0];
      if (selectedImage) {
        // Set the selected image to editedProduct.image
        this.editedProduct.image = selectedImage;
      }
    },
    fetchCategories() {
      Axios.get("/dashboard/category")
        .then((response) => {
          // console.log(response.data.categories);
          // Get all categories from all pages
          const allCategories = response.data.categories;
          const totalPages = response.data.totalPages;

          // Check if there are more pages to fetch
          if (totalPages > 1) {
            const nextPagePromises = [];

            // Start fetching from page 2, as we already fetched page 1
            for (let page = 2; page <= totalPages; page++) {
              nextPagePromises.push(Axios.get(`/category?page=${page}`));
            }

            // Fetch all pages concurrently
            return Promise.all(nextPagePromises)
              .then((nextPagesResponses) => {
                // Extract categories from all pages
                nextPagesResponses.forEach((pageResponse) => {
                  allCategories.push(...pageResponse.data);
                });

                // Set the categories data
                this.categories = allCategories;
              })
              .catch((error) => {
                // console.error(error);
              });
          } else {
            // If there is only one page, set the categories data directly
            this.categories = allCategories;
          }
        })
        .catch((error) => {
          // console.error(error);
        });
    },
    fetchProductDetails() {
      Axios.get(`/dashboard/product/${this.productId}`)
        .then((response) => {
          this.originalName = response.data.data.name;
          // this.data = response.data.data;
          this.editedProduct.name = response.data.data.name;
          this.editedProduct.description =
            response.data.data.multilingualData.en.description;
          this.editedProduct.description_ar =
            response.data.data.multilingualData.ar.description;
          this.editedProduct.height =
            response.data.data.height;
            this.editedProduct.style =
            response.data.data.multilingualData.en.style;
          this.editedProduct.style_ar =
            response.data.data.multilingualData.ar.style;
          this.editedProduct.depth =
            response.data.data.depth;
          this.editedProduct.execute_ar =
            response.data.data.multilingualData.ar.execute;

          this.editedProduct.categoryId =
            response.data.data.categoryId;
          this.editedProduct.image = response.data.data.image;
        })
        .catch((error) => {
          // console.error(error);
        });
      this.fetchProductMaterials(this.productId);
    },

    toggleEditMode(id) {
      if (!this.editModes[id]) {
        this.$set(this.editModes, id, true);
        // Initialize editPrice with the current price
        const materialPrice = this.editedProduct.materialsProductData.find(mp => mp.id === id);
        if (materialPrice) materialPrice.editPrice = materialPrice.price;
      } else {
        this.$set(this.editModes, id, false);
      }
    },
    savePrice(id) {
      const materialPrice = this.editedProduct.materialsProductData.find(mp => mp.id === id);
      if (materialPrice && materialPrice.editPrice !== undefined) {
        const formData = new FormData();
        formData.append('price', materialPrice.editPrice);

        Axios.patch(`https://jebsenboard.onrender.com/dashboard/materialsPrices/${id}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
          .then(response => {
            // Update the price in your local data, and exit edit mode
            materialPrice.price = materialPrice.editPrice;
            this.toggleEditMode(id);
          })
          .catch(error => {
            // console.error(error);
          });
      }
    },
    addMaterialPrice() {
      const materialsHTML = this.materialsData.map(material => `
    <div key="${material['الرقم التسلسلي']}" class="checkboxes d-flex">
      <input style="text-align:auto;" type="checkbox" name="materialSelection" id="checkbox${material['الرقم التسلسلي']}" class="material-checkbox">
      <label for="checkbox${material['الرقم التسلسلي']}" style="font-size: 14px;" class="px-1 pt-1">${material['الاسم']}</label>
      <input type="text" id="input${material['الرقم التسلسلي']}" class="form-control hidden material-input" placeholder="سعر المنتج بخامة ${material['الاسم']}">
    </div>
  `).join('');

  Swal.fire({
    title: 'إضافة خامة جديدة للمنتج',
    html: `<div style="float:none;"><div class="form-group col-12">${materialsHTML}</div></div>`,
    confirmButtonText: 'حفظ',
    showCancelButton: true,
    cancelButtonText: 'إلغاء',
    preConfirm: () => {
      const selectedMaterials = [];
      document.querySelectorAll('.material-checkbox').forEach(checkbox => {
        if (checkbox.checked) {
          const materialId = checkbox.id.replace('checkbox', '');
          const input = document.getElementById(`input${materialId}`);
          const price = input.value;
          selectedMaterials.push({ materialID: materialId, price: price });
        }
      });
      // Call saveProductMaterials with the selected materials
      this.saveProductMaterials(selectedMaterials);
    },
    didOpen: () => {
  document.querySelectorAll('.material-checkbox').forEach(checkbox => {
    checkbox.addEventListener('change', (event) => {
      // Uncheck all checkboxes except the one that was clicked
      document.querySelectorAll('.material-checkbox').forEach(chk => {
        if (chk !== event.target) {
          chk.checked = false;
          const materialId = chk.id.replace('checkbox', '');
          const input = document.getElementById(`input${materialId}`);
          input.classList.add('hidden');
          input.value = '';
        }
      });

      const materialId = event.target.id.replace('checkbox', '');
      const input = document.getElementById(`input${materialId}`);
      if (event.target.checked) {
        input.classList.remove('hidden');
      } else {
        input.value = '';
        input.classList.add('hidden');
      }
    });
  });
}
  });
},

    toggleInput(materialId) {
      // console.log(materialId);
      const checkbox = document.getElementById('checkbox' + materialId);
      const input = document.getElementById('input' + materialId);
      if (input) {
        if (checkbox.checked) {
          input.classList.remove('hidden');
          // Add material and price to selectedMaterials
          this.productData.selectedMaterials.push({
            materialID: materialId,
            price: 0, // Default price, will be updated on input
          });
        } else {
          input.value = '';
          input.classList.add('hidden');
          this.productData.selectedMaterials = this.productData.selectedMaterials.filter(m => m.materialID !== materialId);
        }
      } else {
        // console.error('Input element not found.');
      }
    },
    updateMaterialPrice(materialId, price) {
      // Find the material and update its price
      const material = this.productData.selectedMaterials.find(m => m.materialID === materialId);
      if (material) {
        material.price = price;
      }
    },

  },
  mounted() {
    //this.localeditedProduct = { ...this.editedProduct }; // Make a copy of the prop
    this.fetchProductDetails();
    this.fetchCategories();
    this.fetchMaterials();
  },
};
</script>

<style>
.hidden {
  display: none;
}
</style>